import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommissioningService } from '../commissioning.service';
import { ModalAction } from '../commissioning.model';

@Component({
  selector: 'app-commissioning-spinner',
  templateUrl: './commissioning-spinner.component.html',
  styleUrls: ['./commissioning-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningSpinnerComponent {
  @Input() title?: string;
  @Input() message: string;

  constructor(private commissioningService: CommissioningService) {}

  closeDialog(): void {
    this.commissioningService.modalAction$.next(ModalAction.Close);
  }
}
